export default "__VITE_ASSET__CBdwPp7q__"